import { InjectionToken } from '@angular/core';
import { SessionsPort } from './sessions.port';

export const SESSIONS_PORT = new InjectionToken<SessionsPort>('SESSIONS_PORT');
